import api from '@/modules/api'
export default {
  state: {
    AllFeedback: [],
    ReadFeedbackIds: [],
    Pageno: 1,
    TotalPageCount: 0,
    FormmessageDetailViewId: 0,
    ClientInformation: {}
  },
  getters: {
    AllFeedback: state => state.AllFeedback,
    ReadFeedbackIds: state => state.ReadFeedbackIds,
    Pageno: state => state.Pageno,
    TotalPageCount: state => state.TotalPageCount,
    FormmessageDetailViewId: state => state.FormmessageDetailViewId,
    ClientInformation: state => state.ClientInformation
  },
  mutations: {
    setAllFeedback (state, payload) {
      state.AllFeedback = []
      state.AllFeedback = payload
    },
    setPageno (state, payload) {
      state.Pageno = payload
    },
    setTotalPageCount (state, payload) {
      state.TotalPageCount = payload
    },
    setReadFeedbackIds (state, payload) {
      state.ReadFeedbackIds = payload
    },
    setFormmessageDetailViewId (state, payload) {
      state.FormmessageDetailViewId = payload
    },
    setClientInformation (state, payload) {
      state.ClientInformation = payload
    }
  },
  actions: {
    getClientInformation: async ({ commit }, Id) => {
      let ClientInformation = await api.user.getClientInfo(Id)
      commit('setClientInformation', ClientInformation[0])
    },
    getFeedbackCount: async ({ commit }, payload) => {
      let feedbackdata = await api.Feedback.NotificationCount(payload.Id, payload.NotificationType)
      commit('setTotalPageCount', feedbackdata)
    },
    getFeedbackData: async ({ commit }, payload) => {
      let feedbackdata = await api.Feedback.getSubscriptionsAccountNotificationsData(payload.Id, payload.language, payload.NotificationType, payload.skip * payload.fetch, payload.fetch)
      commit('setAllFeedback', feedbackdata)
      feedbackdata = feedbackdata ? feedbackdata.filter(o => o.NotificationSighted === false) : ''
      if (feedbackdata.length > 0) {
        let tbl = []
        feedbackdata.forEach(val => {
          tbl.push(val.Id)
        })
        await api.Feedback.setNotificationSighted(tbl)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/FeedbackService.js